import React, { useEffect, useMemo } from 'react';
import CustomSelect from '../../components/CustomSelect';
import { sentimentOptions } from '../../constants/sentiment';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { SingleCommonType } from '../../types';
import { sentimentClausePlaceholder } from '../../constants/placeholder';
import { commonBackInfo } from '../../utils';
import SvgIcon from '@/pages/home/components/SvgIcon';
import './index.scss';
import { sentimentIconMap } from '@/pages/opinion/constants';
import { useIntl } from 'umi';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function SentimentClauseSelect({
  onChange,
  defaultKey,
  defaultValue,
  filterValue,
  lang,
}: SingleCommonType) {
  const { formatMessage } = useIntl();
  const {
    selects: selectSentiment,
    setSelects: setSelectSentiment,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'sentiment_clause',
    options: sentimentOptions(formatMessage).map((item) => item.value),
  });

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      'sentiment_clause',
      commonBackInfo(
        { sentiment_clause: selectSentiment.map(Number) },
        { [defaultKey]: text },
        { needChangeEntity: true, isNumber: true, isAll },
      ),
    );
  }, [selectSentiment]);

  const sentimentValue = useMemo(() => {
    return selectSentiment.map(String);
  }, [selectSentiment]);

  return (
    <div className={`sentiment-clause-select-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        buttonItemRender={(value: any) => {
          return (
            <SvgIcon
              type={sentimentIconMap[value]}
              className="dbo-select-icon"
            />
          );
        }}
        buttonAllRender={[5, 1, 3].map((value) => (
          <SvgIcon
            key={value}
            type={sentimentIconMap[value]}
            className="dbo-select-icon"
          />
        ))}
        placeholderText={sentimentClausePlaceholder[lang]}
        onClear={() => setSelectSentiment([])}
        selectOptionsInfo={[sentimentValue, setSelectSentiment]}
        options={sentimentOptions(formatMessage)}
        pointKey={FilterButtonPoint.sentimentClause}
      ></CustomSelect>
    </div>
  );
}
